import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Component, OnInit, Inject } from "@angular/core";
import { NgIf } from "@angular/common";
import { CommentaryBoxComponent } from "../comentarios/commentary-box.component";

@Component({
  selector: "app-modal-comentarios",
  templateUrl: "./modal-comentarios.component.html",
  styleUrls: ["./modal-comentarios.component.css"],
  imports: [NgIf, CommentaryBoxComponent],
})
export class ModalComentariosComponent implements OnInit {
  idVideo = "";
  constructor(
    public dialogRef: MatDialogRef<ModalComentariosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idNoticia: string },
  ) {}
  ngOnInit(): void {
    this.idVideo = this.data.idNoticia;
  }
}
